import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {SinkLabor} from "../types/SinkLabor";

export const useGetSinkLabor = (dealerID: number, prodQteGrpID: number, ironType: number, zipCode: string) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-pro-sink-labor', prodQteGrpID, dealerID, ironType, zipCode],
        queryFn: async () => await apiClient.get('ee-pro/sink-labor?dealerID=' + dealerID + '&prodQteGrpID=' + prodQteGrpID + '&ironType=' + ironType + '&zipCode=' + zipCode) as SinkLabor,
        enabled: prodQteGrpID > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || undefined,
        isLoading: isLoading
    };
};
